/*eslint-disable*/
import React from "react";

export default function Footer() {
  return (
    <div className="z-[5] mx-auto flex w-full max-w-screen-sm flex-col items-center justify-between px-[20px] pb-4 lg:mb-6 lg:max-w-[100%] lg:flex-row xl:mb-2 xl:w-[1310px] xl:pb-6">
      <p className="mb-6 text-center text-sm text-gray-900 dark:text-gray-400 md:text-base lg:mb-0">
        ©{1900 + new Date().getYear()} SNORI. All Rights Reserved.
      </p>
      <p className="text-center text-sm text-gray-100 dark:text-gray-400 md:text-base">
        Developed By{" "}
        <a
          href="https://brandwisetech.com"
          target="_blank"
          rel="noopener noreferrer"
          className="text-blue-400 hover:text-blue-400 font-bold dark:text-blue-400 dark:hover:text-blue-300"
        >
          BrandWise Tech
        </a>
      </p>
    </div>
  );
}